var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-row section-image"},[_c('div',{staticClass:"section-image-container"},[_c('img',{attrs:{"src":`./static/images/screens/${_vm.data.value}`,"alt":"..."}}),_c('div',{staticClass:"section-image-expand",on:{"click":function($event){$event.preventDefault();return _vm.onClick()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }